export const platformAddress = import.meta.env.VITE_APP_PLATFORM_ADDRESS;
export const destinationEmailBase = import.meta.env.VITE_APP_EMAIL_BASE;
export const accountId = import.meta.env.VITE_APP_ACCOUNT_ID;
export const namespaceId = import.meta.env.VITE_APP_NAMESPACE_ID;
export const cloudflareProxyWorkerUrl = import.meta.env
  .VITE_APP_CLOUDFLARE_PROXY_WORKER_URL;
